module.exports = __webpack_public_path__ + "select-arrows-error-60030d2450c1f85ded832886ccac4e35.svg";